import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../core/modal.component';
import { ActiveModal } from '../../../core/modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ObjectField } from '../../../models/project';
import { ObjectFieldService } from '../../object-field.service';

@Component({
  selector: 'cw-edit-object-field',
  templateUrl: './edit-object-field.component.html',
  styleUrls: ['./edit-object-field.component.scss']
})
export class EditObjectFieldComponent extends ModalComponent implements OnInit {
  form: FormGroup;
  isSaving: boolean;

  constructor(public modal: ActiveModal,
              private fb: FormBuilder,
              private fieldService: ObjectFieldService) {
    super(modal);
    this.createForm();
  }

  ngOnInit(field?: ObjectField) {
  }

  save() {
    const value = this.form.value;

    this.isSaving = true;
    this.fieldService.create(value)
      .finally(() => {
        this.isSaving = false
      })
      .subscribe(field => {
        this.modal.close(field);
      });
  }

  private createForm() {
    this.form = this.fb.group({
      type: [this.types[0].value, Validators.required],
      label: ['', Validators.required],
      key: ['', Validators.required]
    });
  }

  get types() {
    return [
      { value: 'string', label: 'Text' },
      { value: 'integer', label: 'Heltal' }
    ]
  }

  get opened() {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/object-fields/edit-object-field/edit-object-field.component.ts